var _g, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtnCal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "btn_cal",
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "valentines-day-calendar-svgrepo-com_1_",
    "data-name": "valentines-day-calendar-svgrepo-com (1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4013",
    "data-name": "\\uD328\\uC2A4 4013",
    d: "M0,178.087v33.63a5.909,5.909,0,0,0,5.87,5.935H54.13A5.909,5.909,0,0,0,60,211.717v-33.63Z",
    transform: "translate(0 -157.652)",
    fill: "#dddbd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4014",
    "data-name": "\\uD328\\uC2A4 4014",
    d: "M256,217.652h24.4a5.941,5.941,0,0,0,5.935-5.935v-33.63H256Z",
    transform: "translate(-226.333 -157.652)",
    fill: "#dddbd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4017",
    "data-name": "\\uD328\\uC2A4 4017",
    d: "M54.13,44.522H5.87A5.909,5.909,0,0,0,0,50.457v11.21H60V50.457A5.909,5.909,0,0,0,54.13,44.522Z",
    transform: "translate(0 -39.247)",
    fill: "#ee8975"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4018",
    "data-name": "\\uD328\\uC2A4 4018",
    d: "M280.4,44.522H256V61.667h30.333V50.457A5.941,5.941,0,0,0,280.4,44.522Z",
    transform: "translate(-226.333 -39.247)",
    fill: "#ee8975"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4019",
    "data-name": "\\uD328\\uC2A4 4019",
    d: "M369.282,15.826a1.978,1.978,0,0,1-1.978-1.978V1.978a1.978,1.978,0,1,1,3.957,0v11.87A1.978,1.978,0,0,1,369.282,15.826Z",
    transform: "translate(-324.294)",
    fill: "#4dbfbf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4020",
    "data-name": "\\uD328\\uC2A4 4020",
    d: "M113.282,15.826a1.978,1.978,0,0,1-1.978-1.978V1.978a1.978,1.978,0,0,1,3.957,0v11.87A1.978,1.978,0,0,1,113.282,15.826Z",
    transform: "translate(-98.271)",
    fill: "#57d4d4"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_1197",
    "data-name": "\\uC0AC\\uAC01\\uD615 1197",
    width: 51,
    height: 30,
    rx: 3,
    transform: "translate(4 25.567)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnCal);
export default __webpack_public_path__ + "static/media/btn_cal.03e007bc528ce9e6533e00a0f0171f2c.svg";
export { ForwardRef as ReactComponent };